import { themedStyled } from 'common/styles/styletron.theme';

export const ScheduleCardHeader = themedStyled('div', {
  display: 'flex',
  width: '100%',
});

export const ScheduleCardHeaderLeft = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  [$theme.mediaQuery.md]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
}));
